export default __webpack_public_path__ + "static/media/gameOver.492ea39f.wav";